// src/components/Services.js
import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';

const Services = () => {
  const { language } = useLanguage();

  return (
    <section
      id="portfolio"
      className="bg-portfolio-bg bg-cover bg-no-repeat bg-center py-16 px-4 text-white"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-10">
          {language === 'id' ? 'Layanan yang Saya Tawarkan' : 'What I Offer'}
        </h2>
        <div className="grid md:grid-cols-3 gap-6">

          {/* Business Website */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-gray-100 p-6 rounded shadow text-black transform hover:scale-105 transition duration-300"
          >
            <h3 className="text-xl font-semibold mb-2">
              {language === 'id' ? 'Website Bisnis' : 'Business Website'}
            </h3>
            <p>
              {language === 'id'
                ? 'Website mobile-friendly yang dibuat dengan React.js untuk bisnis jasa atau portofolio.'
                : 'Beautiful mobile-friendly websites with React.js for service-based businesses or portfolios.'}
            </p>
          </motion.div>

          {/* Hosting Setup */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-gray-100 p-6 rounded shadow text-black transform hover:scale-105 transition duration-300"
          >
            <h3 className="text-xl font-semibold mb-2">
              {language === 'id' ? 'Pengaturan Hosting' : 'Hosting Setup'}
            </h3>
            <p>
              {language === 'id'
                ? 'Saya bantu menghubungkan domain Anda ke server A2Hosting saya dengan pengaturan dan konfigurasi keamanan profesional.'
                : 'I help connect your domain to my A2Hosting server with professional setup and security configuration.'}
            </p>
          </motion.div>

          {/* Ongoing Support */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="bg-gray-100 p-6 rounded shadow text-black transform hover:scale-105 transition duration-300"
          >
            <h3 className="text-xl font-semibold mb-2">
              {language === 'id' ? 'Dukungan Berkelanjutan' : 'Ongoing Support'}
            </h3>
            <p>
              {language === 'id'
                ? 'Saya menyediakan pembaruan konten, optimisasi performa, dan bantuan SEO dasar setelah peluncuran.'
                : 'I provide content updates, performance optimization, and basic SEO assistance after launch.'}
            </p>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Services;
